import {ROOM_CLIENT_UPDATE_OFFLINE} from '../constants/users';

export function updateUserOffline(user, room_id) {
    return {
        type: ROOM_CLIENT_UPDATE_OFFLINE,
        roomid: room_id,
        user
    }
}


// WEBPACK FOOTER //
// ./src/actions/rooms.js